"use strict";

exports.__esModule = true;
exports.default = void 0;

var _pagination = require("./pagination");

var _plugins = require("../../utils/plugins");

var components = {
  BPagination: _pagination.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/pagination/index.js
// module id = gEcC
// module chunks = 14